import { createFileRoute } from "@tanstack/react-router";
import SaintTherapyCoralSpringsFlEs from "@/pages/es/SaintTherapyCoralSpringsFlEs";
import { SITE_URL, buildHreflang } from "@/lib/i18n/locale";

const ES_URL = `${SITE_URL}/es/saint-therapy-coral-springs-fl`;

export const Route = createFileRoute("/es/saint-therapy-coral-springs-fl")({
  head: () => ({
    meta: [
      { title: "SAINT® TMS en Coral Springs, FL | Neuro Wellness TMS" },
      {
        name: "description",
        content:
          "SAINT® TMS en Coral Springs, FL — TMS acelerada de 5 días guiada por fMRI para la depresión resistente al tratamiento en Neuro Wellness TMS Centers of.",
      },
      { property: "og:title", content: "SAINT® TMS en Coral Springs, FL" },
      {
        property: "og:description",
        content:
          "SAINT® TMS en Coral Springs, FL — TMS acelerada de 5 días guiada por fMRI para la depresión resistente al tratamiento.",
      },
      { property: "og:url", content: ES_URL },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "es_ES" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "SAINT® TMS en Coral Springs, FL" },
      {
        name: "twitter:description",
        content:
          "SAINT® TMS en Coral Springs, FL — TMS acelerada de 5 días guiada por fMRI para la depresión resistente al tratamiento.",
      },
    ],
    links: [
      { rel: "canonical", href: ES_URL },
      ...buildHreflang("/saint-therapy-coral-springs-fl"),
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <SaintTherapyCoralSpringsFlEs />;
}
